import { WitboostCommercialModule } from '@agilelab/plugin-wb-platform-common';
import { CustomViewPageCategory } from '../components/CustomView/pages';

/**
 * Decide visibility using commercial modules directly.
 * Uses the mapping from commercial → internal modules via getLicensedModules in context.
 * The predicate should accept commercial modules.
 */
export function shouldShowTabByCommercialModules(
  requiredCommercial: WitboostCommercialModule[] | undefined,
  isCommercialModuleLicensed: (module: WitboostCommercialModule) => boolean,
): boolean {
  if (!requiredCommercial || requiredCommercial.length === 0) return true;
  return requiredCommercial.some(isCommercialModuleLicensed);
}

/**
 * Map custom view categories to their required commercial module.
 */
export const categoryToCommercial: Record<
  CustomViewPageCategory,
  WitboostCommercialModule
> = {
  [CustomViewPageCategory.MARKETPLACE]: WitboostCommercialModule.MarketPlane,
  [CustomViewPageCategory.BUILDER]: WitboostCommercialModule.ControlPlane,
  [CustomViewPageCategory.PRACTICE_SHAPER]:
    WitboostCommercialModule.ControlPlane,
};
